import Mapper from '../core/service/Mapper';

const url = 'indicadores';
class IndicadorService {
    constructor() {
        this.mapper = new Mapper();
    }

    async beforeSetList(dados, config) {
        return await this.mapper.formatToView(dados, config);
    }

    async pesquisar(paginate) {
        paginate.sort = [{ field: 'nmIndicador', order: 'asc' }];
        const res = await window.$http.get(url, paginate.getParams());
        return res?.data ?? [];
    }

    async buscarPorId(id) {
        const res = await window.$http.get(url, { params: { search: `id==${id}` } });
        return res?.data?.content ?? [];
    }

    async getCabecalho(idIndicador) {
        const res = await window.$http.get(`${url}/${idIndicador}`);
        return res?.data;
    }

    async getDadosGerais({ idProposta }) {
        const response = await window.$http.get(`${url}/dados-gerais/${idProposta}`);
        return response.data;
    }
    async getDadosComplementares(idIndicador, form) {
        const response = await window.$http.get(`${url}/dados-complementares/${idIndicador}`);
        return this.mapper.formatToInput(response.data, form);
    }

    async getSerieHistorica(idIndicador) {
        const response = await window.$http.get(`${url}/serie-historica/${idIndicador}`);
        return response.data;
    }

    async alterarIndicador(idIndicador) {
        const response = await window.$http.patch(`${url}/alteracao/${idIndicador}`);
        return response;
    }

    async exportaDataToFile(params, type, titleFile, filter, configuracao) {
        const exportConfig = this.getExportConfig(type, configuracao);
        const typeRoute = type === 'print' ? 'pdf' : type;
        const body = {
            params,
            body: {
                title: titleFile,
                ...exportConfig,
                ...filter,
            },
        };

        const res = await window.$http.post(`${url}/export/${typeRoute}`, body, {
            responseType: 'blob',
        });

        return res.data;
    }
    getExportConfig(type, configuracao) {
        if (configuracao[type]) {
            return {
                columns: configuracao[type].columns,
                properties: configuracao[type]['properties'],
            };
        }
        return {
            columns: configuracao.columns,
            properties: configuracao.properties,
        };
    }

    async getRelatorioIndicador(idIndicador) {
        const response = await window.$http.get(`${url}/relatorios/indicador/${idIndicador}`, {
            responseType: 'blob',
        });

        return response.data;
    }

    async getIndicadorByProposta(idProposta) {
        const response = await window.$http.get(`${url}/find-indicador/${idProposta}`);
        return response.data;
    }
}

export default new IndicadorService(url);
